import { Star } from "lucide-react";
import { hasStory } from "../lib/stories";

// A quiet mark for the paintings the artist holds dearest.
export const FavouriteMark = ({ painting, testid, className = "" }) =>
  painting?.favourite ? (
    <span data-testid={testid} className={`inline-flex items-center gap-1 font-display text-sm italic text-[#9A6A3A] ${className}`}>
      <Star aria-hidden className="h-3 w-3" strokeWidth={1.5} />
      the artist's favourite
    </span>
  ) : null;

// A small note that this painting has an "Experience the painting ✦" story.
export const StoryMark = ({ painting, testid, className = "" }) =>
  hasStory(painting) ? (
    <span data-testid={testid} className={`inline-flex items-center font-display text-sm italic text-[#7E57C2] ${className}`}>
      has a story ✦
    </span>
  ) : null;
